import React, { useState } from 'react';
import {
  Box,
  Typography,
  Grid,
  TextField,
  Button,
  Container,
  Paper,
  Divider,
  useTheme,
  useMediaQuery,
  Stack,
  Chip,
  IconButton
} from '@mui/material';
import {
  LocationOn,
  Phone,
  Email,
  Schedule,
  Facebook,
  Instagram,
  Twitter,
  LinkedIn,
  Send,
  WhatsApp
} from '@mui/icons-material';

const ContactUs = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Thank you for your message! We will contact you soon.');
    setFormData({
      name: '',
      email: '',
      phone: '',
      message: ''
    });
  };

  const contactMethods = [
    {
      icon: <LocationOn color="primary" fontSize="large" />,
      title: 'Our Office',
      details: 'Plot 724,725, 7th Main Road, 707, TNHB Colony Road,\n Sithalapakkam , Chennai\nTamil Nadu 627126'
    },
    {
      icon: <Phone color="primary" fontSize="large" />,
      title: 'Phone',
      details: '+91 96296 11466\nMonday - Saturday : 10AM - 6PM'
    },
    {
      icon: <Email color="primary" fontSize="large" />,
      title: 'Email',
      details: 'jemins_realmart@jemins.in'
    },
    {
      icon: <Schedule color="primary" fontSize="large" />,
      title: 'Hours',
      details: 'Monday - Saturday: 10 AM - 6 PM\nSunday: Closed'
    }
  ];

  return (
    <Box sx={{
      backgroundColor: theme.palette.background.default,
      py: 8
    }}>
      <Container maxWidth="lg">
        <Typography variant="h3" component="h1" gutterBottom sx={{
          fontWeight: 700,
          textAlign: 'center',
          mb: 4,
          color: theme.palette.text.primary
        }}>
          Contact Us
        </Typography>

        <Typography variant="h6" component="h2" sx={{
          textAlign: 'center',
          mb: 6,
          color: theme.palette.text.secondary,
          maxWidth: '700px',
          mx: 'auto'
        }}>
          Have questions about properties, listings, or our services? Reach out to our team - we're here to help you with all your real estate needs.
        </Typography>

        <Paper elevation={3} sx={{
          p: isMobile ? 2 : 4,
          borderRadius: 2,
          mb: 6
        }}>
          <Grid container spacing={4}>
            {/* Contact Form */}
            {/* <Box
              sx={{
                // py: 6,
                // px: 2,
              
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Paper
                elevation={3}
                sx={{
                  p: { xs: 3, sm: 4 },
                  borderRadius: 3,
                  width: "100%",
                  maxWidth: 600,
                  backgroundColor: "#fff",
                }}
              >
                <Typography
                  variant="h5"
                  component="h3"
                  gutterBottom
                  sx={{
                    fontWeight: 700,
                    color: theme.palette.primary.main,
                    mb: 3,
                  }}
                >
                  Send Us a Message
                </Typography>

                <Box component="form" onSubmit={handleSubmit} noValidate>
                  <Stack spacing={2}>
                    <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
                      <TextField
                        fullWidth
                        label="Your Name"
                        name="name"
                        variant="filled"
                        value={formData.name}
                        onChange={handleChange}
                        required
                      />
                      <TextField
                        fullWidth
                        label="Email Address"
                        type="email"
                        name="email"
                        variant="filled"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                    </Stack>

                    <TextField
                      fullWidth
                      label="Phone Number"
                      name="phone"
                      variant="filled"
                      value={formData.phone}
                      onChange={handleChange}
                    />

                    <TextField
                      fullWidth
                      label="Your Message"
                      name="message"
                      multiline
                      rows={4}
                      variant="filled"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    />

                    <Button
                      type="submit"
                      variant="contained"
                      size="large"
                      endIcon={<Send />}
                      sx={{
                        mt: 1,
                        px: 4,
                        py: 1.5,
                        fontWeight: 600,
                        fontSize: "1rem",
                        borderRadius: 2,
                        textTransform: "none",
                        transition: "background 0.3s",
                        ":hover": {
                          backgroundColor: theme.palette.primary.dark,
                        },
                      }}
                    >
                      Send Message
                    </Button>
                  </Stack>
                </Box>
              </Paper>
            </Box> */}


            {/* Contact Info */}
            <Grid item xs={12} md={6}>
              <Typography variant="h5" component="h3" gutterBottom sx={{
                fontWeight: 600,
                mb: 3,
                color: theme.palette.primary.main
              }}>
                Contact Information
              </Typography>

              <Stack spacing={3}>
                {contactMethods.map((method, index) => (
                  <Box key={index} sx={{ display: 'flex', gap: 2 }}>
                    <Box sx={{ mt: 0.5 }}>
                      {method.icon}
                    </Box>
                    <Box>
                      <Typography variant="h6" component="h4" sx={{ fontWeight: 600, mb: 0.5 }}>
                        {method.title}
                      </Typography>
                      <Typography variant="body1" sx={{ whiteSpace: 'pre-line' }}>
                        {method.details}
                      </Typography>
                    </Box>
                  </Box>
                ))}
              </Stack>

              <Divider sx={{ my: 4 }} />

              <Typography variant="h6" component="h4" sx={{ fontWeight: 600, mb: 2 }}>
                Follow Us
              </Typography>

                <Stack direction="row" spacing={2}>
                            {[
                              {
                                icon: <Facebook />,
                                color: '#1877F2',
                                url: 'https://www.facebook.com/jemins.builders'
                              },
                              {
                                icon: <Instagram />,
                                color: '#E4405F',
                                url: 'https://www.instagram.com/jemins.builders'
                              },
                              // {
                              //   icon: <Twitter />,
                              //   color: '#1DA1F2',
                              //   url: 'https://www.twitter.com/your-profile'
                              // },
                              // {
                              //   icon: <LinkedIn />,
                              //   color: '#0A66C2',
                              //   url: 'https://www.linkedin.com/in/your-profile'
                              // },
                              {
                                icon: <WhatsApp />,
                                color: '#25D366',
                                url: `https://wa.me/919629611466`
                              }
                            ].map((social, index) => (
                              <IconButton
                                key={index}
                                onClick={() => window.open(social.url, '_blank')}
                                sx={{
                                  backgroundColor: theme.palette.mode === 'dark'
                                    ? theme.palette.grey[800]
                                    : theme.palette.grey[100],
                                  color: social.color,
                                  '&:hover': {
                                    backgroundColor: social.color,
                                    color: '#fff',
                                    transform: 'translateY(-2px)'
                                  },
                                  transition: 'all 0.3s ease',
                                  width: 40,
                                  height: 40
                                }}
                              >
                                {social.icon}
                              </IconButton>
                            ))}
                          </Stack>
            </Grid>
          </Grid>
        </Paper>

        {/* Map Section */}
        <Typography variant="h5" component="h3" gutterBottom sx={{
          fontWeight: 600,
          mb: 3,
          color: theme.palette.primary.main
        }}>
          Our Location
        </Typography>

        <Box sx={{
          height: isMobile ? '300px' : '400px',
          width: '100%',
          borderRadius: 2,
          overflow: 'hidden',
          mb: 6
        }}>
          <iframe
            title="Our Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3022.215373510518!2d-73.9878449241646!3d40.74844047138961!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c259a9b3117469%3A0xd134e199a405a163!2sEmpire%20State%20Building!5e0!3m2!1sen!2sus!4v1683037460420!5m2!1sen!2sus"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </Box>

       
      </Container>
    </Box>
  );
};

export default ContactUs;